import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getRewardConfiguration: any = createAsyncThunk<any>(
    'getRewardConfiguration',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/configuration',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const updateRewardConfiguration: any = createAsyncThunk<any>(
    'updateRewardConfiguration',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/tenant-portal/rewardProgram/configuration',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardProgram: any = createAsyncThunk<any>(
    'getRewardProgram',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const addRewardProgram: any = createAsyncThunk<any>(
    'addRewardProgram',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                '/tenant-portal/rewardProgram',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const updateRewardProgram: any = createAsyncThunk<any>(
    'updateRewardProgram',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/tenant-portal/rewardProgram',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getClaimsList: any = createAsyncThunk<any>(
    'getClaimsList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/productClaims',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const updateClaimStatus: any = createAsyncThunk<any>(
    'updateClaimStatus',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/tenant-portal/rewardProgram/productClaims',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardsList: any = createAsyncThunk<any>(
    'getRewardsList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/product',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const createReward: any = createAsyncThunk<any>(
    'createReward',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                '/tenant-portal/rewardProgram/product',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const editReward: any = createAsyncThunk<any>(
    'editReward',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/tenant-portal/rewardProgram/product',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const deleteReward: any = createAsyncThunk<any>(
    'deleteReward',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.delete(
                '/tenant-portal/rewardProgram/product',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const updateRewardStatus: any = createAsyncThunk<any>(
    'updateRewardStatus',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.patch('/tenant-portal/rewardProgram/product', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardProductsList: any = createAsyncThunk<any>(
    'getRewardProductsList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/productService/productV2/rewardProductList',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getMembersList: any = createAsyncThunk<any>(
    'getMembersList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/members',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getMemberCustomerList: any = createAsyncThunk<any>(
    'getMemberCustomerList',
    async (data: any) => {
        const response = await httpService.get(`/tenant-portal/customerRewardProgram`, {
            params: data
        });
        return response.data.data;
    }
);

export const enrollMember: any = createAsyncThunk<any>(
    'enrollMember',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                '/tenant-portal/rewardProgram/members',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const unEnrollMember: any = createAsyncThunk<any>(
    'unEnrollMember',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.delete(
                '/tenant-portal/rewardProgram/members',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getPaymentTerms: any = createAsyncThunk<any>(
    'getPaymentTerms',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/paymentTerms',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getMembersDetails: any = createAsyncThunk<any>(
    'getMembersDetails',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/member',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getPointLogs: any = createAsyncThunk<any>(
    'getPointLogs',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/point',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardDashboardStats: any = createAsyncThunk<any>(
    'getRewardDashboardStats',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/pointsSummary',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardDashboardHistoric: any = createAsyncThunk<any>(
    'getRewardDashboardHistoric',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/pointsHistoricDistribution',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardMemberCount: any = createAsyncThunk<any>(
    'getRewardMemberCount',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/memberCount',
                {
                    params: data
                }
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getRewardTagSuggestion: any = createAsyncThunk<any>(
    'getRewardTagSuggestion',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/tenant-portal/rewardProgram/productTags',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);